import './UserHeader.scss';
import project from 'assets/images/icons/user-project.svg';
import requests from 'assets/images/icons/user-requests.svg';
import calendar from 'assets/images/icons/user-agenda.svg';
import add from 'assets/images/icons/user-ask-appointment.svg';
import cross from 'assets/images/icons/croix.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getItemSelected } from 'features/menu/menu.slice';
import logo from 'assets/images/logo-colored.svg';
import { getUser } from 'features/auth/auth.slice';
import useUserHeaderVM from './useUserHeaderVM';

export type UserHeaderProps = {
    title: string;
};

export type UserHeaderItemsType = {
    label: string;
    iconSrc: string;
    url: string;
};

export const userHeaderItems: UserHeaderItemsType[] = [
    {
        label: 'Mon projet de vie',
        iconSrc: project,
        url: '/app/user'
    },
    {
        label: 'Mes demandes',
        iconSrc: requests,
        url: '/app/user/requests'
    },
    {
        label: 'Agenda',
        iconSrc: calendar,
        url: '/app/user/agenda'
    },
    {
        label: 'Demandes de rendez-vous',
        iconSrc: add,
        url: '/app/user/appointments'
    },
    {
        label: 'Déconnexion',
        iconSrc: cross,
        url: '#'
    }
];

export const UserHeader: React.FC<UserHeaderProps> = ({ title }) => {
    const selectedItem = useSelector(getItemSelected);
    const user = useSelector(getUser);
    const { handleMenuClick } = useUserHeaderVM();

    return (
        <>
            <div className="user-header">
                <div className="header">
                    <div className="header-logo">
                        <img src={logo} className="logo" alt="logo" />
                        <span>Bonjour {user?.firstname}</span>
                    </div>
                    <div className="links">
                        {userHeaderItems.map(({ label, iconSrc, url }: UserHeaderItemsType, index: number) => (
                            <Link
                                key={index}
                                to={label !== 'Déconnexion' ? url : '#'}
                                className={`link ${selectedItem === index ? 'selected' : ''}`}
                                onClick={() => {
                                    handleMenuClick(label, index);
                                }}
                            >
                                <img src={iconSrc} alt={label} />
                                <span>{label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className="header-title">
                    `
                    <div className="header-title-content">
                        <h1>{selectedItem !== undefined ? userHeaderItems[selectedItem].label : title}</h1>
                    </div>
                </div>
            </div>
        </>
    );
};
